<script lang="ts">
  import { urls } from './utils/urls'
  import { initFonts } from './activate-fonts'

  export let theme: string
  export let language: string
  export let successurl: string

  let showCentreSearchLink = false
  let code: string
  let error: { show: boolean; title: string; message: string } = {
    show: false,
    title: 'CODE NOT RECOGNISED',
    message:
      'Unfortunately, the voucher code you entered cannot be used for this Experience. Please contact our Experience team at your chosen centre.',
  }

  $: {
    if (!!theme) {
      initFonts(theme)
    }
  }

  const handleRequest = async () => {
    const url = new URL(urls.search + '/voucher-code/' + code)

    try {
      const res = await fetch(url.toString())
      handleResponse({
        res,
        status: res.status,
      })
    } catch (_) {
      error.show = true
    }
  }

  const handleResponse = (data: { res: any; status: number }) => {
    const { status } = data
    if (status === 200) {
      window.location.href = successurl
      return
    } else {
      error.show = true
    }
  }

</script>

<svelte:options tag="jlre-voucher-sdk" />

<main>
  <div class="container">
    <h3>
      Please input your unique voucher code to start your booking process.
    </h3>
    <p>
      Your voucher code can be found on your invitation. If you do not have your
      voucher code, please call your chosen centre:
    </p>

    <ul class="contactsList">
      <li class="contact">
        <span class="contactName">Scotland</span> 
        <span class="contactCity">Dunkeld</span>
        <span class="contactNumber">01350 727720</span>
      </li>
      <li class="contact">
        <span class="contactName">North Yorkshire</span>
        <span class="contactCity">Skipton</span>
        <span class="contactNumber">01756 611060</span>
      </li>
      <li class="contact"><span class="contactName">Liverpool</span>
         <span class="contactCity">Halewood</span>
         <span class="contactNumber">01514 484023</span>
       </li>
       <li class="contact">
        <span class="contactName">Cheshire</span> 
        <span class="contactCity">Tarporley</span> 
        <span class="contactNumber">01829 262864</span> 
      </li>
      <li class="contact">
        <span class="contactName">Midlands</span> 
        <span class="contactCity">Solihull</span> 
        <span class="contactNumber">01217 003545</span> 
      </li>
      <li class="contact">
        <span class="contactName">Herefordshire</span> 
        <span class="contactCity">Eastnor</span>
         <span class="contactNumber">01531 638777</span>
       </li>
       <li class="contact">
        <span class="contactName">East of England</span>
         <span class="contactCity">Rockingham</span> 
         <span class="contactNumber">01536 772238</span>
       </li>
       <li class="contact">
        <span class="contactName">London</span>
         <span class="contactCity">Luton</span> 
         <span class="contactNumber">01989 770932</span> 
        </li>
        <li class="contact">
          <span class="contactName">West Country</span> 
          <span class="contactCity">Honiton</span> 
          <span class="contactNumber">01404 549333</span> 
        </li>
      </ul>

    <form id="form" on:submit|preventDefault="{handleRequest}">
      <input
        class="{error.show ? 'error' : 'clean'}"
        id="input"
        type="text"
        name="code"
        bind:value="{code}"
        placeholder="Voucher Code"
      />
      {#if error.show}
        <div id="errorContainer">
          <h4 id="errorTitle">{error.title}</h4>
          <p id="errorMessage">{error.message}</p>
          {#if showCentreSearchLink}
            <a href="/" class="external">Explore experiences at ..</a>
          {/if}
        </div>
      {/if}
      <button id="submit" disabled="{!code}">Submit</button>
    </form>
  </div>
</main>

<style lang="scss">

.contactsList {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
    list-style: none;
    padding: 0;
    color: #666;
}

.contact {
    font-size: 14px;
}

.contactName {
    font-family: var(--bold-font-face);
    color: black;
}
.contactNumber {
    font-family: var(--bold-font-face);
    color: black;
}
  :root {
    --bold-font-face: '';
    --regural-font-face: '';
    --accent-color: '';
    --error-color: '';
  }

  main {
    padding: 120px 100px;
    font-family: var(--regular-font-face);
  }

  h3 {
    font-family: var(--bold-font-face);
    text-transform: uppercase;
    margin-bottom: 1rem;
  }

  p {
    color: #666;
  }

  input {
    display: block;
    padding: 13px 20px 10px;
    min-width: 60%;
    margin-bottom: 20px;
    color: #6b7275;
    border: 2px solid #c1c2c3;
    text-transform: uppercase;
  }

  input.error {
    border-color: #ce2821;
  }

  form {
    display: block;
  }

  .container {
    padding: 24px 0;
  }

  #errorContainer {
    padding: 15px 40px;
    background: #e8eced;
    margin-bottom: 20px;
  }

  #errorTitle {
    color: #ce2821;
    text-transform: uppercase;
  }

  #errorMessage {
    line-height: 1.8rem;
  }

  #submit,
  .external {
    padding: 10px 20px 8px;
    border: none;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 1px;
    background: #0c121c;
    color: white;
    cursor: pointer;
  }

  #submit[disabled] {
    background-color: #e8eced;
    cursor: not-allowed;
  }

</style>
